export function getSupportEntityMarkerId(kind: string, id: string) {
  return `support-entity-${kind}-${id}`
}

export function getSupportEntityTimelineRowId(kind: string, id: string) {
  return `support-entity-timeline-row-${kind}-${id}`
}

export function scrollToSupportEntityMarker(kind: string, id: string) {
  const anchor = document.getElementById(getSupportEntityMarkerId(kind, id))
  const marker = anchor?.closest<HTMLElement>("[data-support-entity-marker]")
  if (!marker) return

  marker.scrollIntoView({ behavior: "smooth", block: "center" })
  marker.classList.add("active-group")
  window.setTimeout(() => marker.classList.remove("active-group"), 2000)
}

export function scrollToSupportEntityTimelineRows(items: { kind: string; id: string }[]) {
  const rows = items.flatMap(({ kind, id }) => {
    const rowId = getSupportEntityTimelineRowId(kind, id)

    return Array.from(document.querySelectorAll<HTMLElement>("[data-support-entity-row]")).filter(
      (row) => row.id === rowId && row.getClientRects().length > 0,
    )
  })

  const firstRow = rows[0]
  if (!firstRow) return

  firstRow.scrollIntoView({ behavior: "smooth", block: "center" })

  for (const row of rows) {
    row.classList.add("active-support-entity")
    window.setTimeout(() => row.classList.remove("active-support-entity"), 2000)
  }
}
